export const sections = [
  { id: 'overview', label: 'Overview', title: 'Overview', intro: 'Summary profile and positioning.' },
  {
    id: 'board-experience',
    label: 'NED & Board Experience',
    title: 'NED & Board Experience',
    intro: 'Board appointments across public companies, public bodies and international research institutions, most recent first.',
  },
  {
    id: 'chair-leadership',
    label: 'Board Chair Leadership',
    title: 'Board Chair & Governance Leadership',
    intro: 'Thirteen chair and presidential roles — evidence of leading board performance, not only contributing to it.',
  },
  {
    id: 'philosophy',
    label: 'Board Philosophy',
    title: 'Board Philosophy & Contribution',
    intro: 'How Jim approaches the work of a board: challenge, judgement and collective responsibility.',
  },
  {
    id: 'governance',
    label: 'Strategic Oversight',
    title: 'Strategic Oversight & Governance',
    intro: 'Committee leadership, audit and risk oversight, and system-wide governance reform.',
  },
  {
    id: 'director-development',
    label: 'Director Development',
    title: 'Director Assessment & Board Development',
    intro: 'Fifteen years training and developing directors and trustees, in the UK and internationally.',
  },
  {
    id: 'contributions',
    label: 'Industry Contributions',
    title: 'Professional & Industry Contributions',
    intro: 'Founding, chairing and advising across the global potato, rice and animal science communities.',
  },
  { id: 'awards', label: 'Awards & Recognition', title: 'Awards & Recognition', intro: 'National and international recognition, 2000 – 2026.' },
  {
    id: 'qualifications',
    label: 'Qualifications',
    title: 'Qualifications & Certificates',
    intro: 'Academic qualifications, professional fellowships and the original certificates.',
  },
  {
    id: 'references',
    label: 'References',
    title: 'Supporting Evidence & Online References',
    intro: 'Independent public profiles confirming current and past appointments.',
  },
  {
    id: 'contact',
    label: 'Contact',
    title: 'Contact',
    intro: 'For Non-Executive Director, Board Chair, advisory and governance enquiries.',
  },
];
